import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import MediaUploader from "./MediaUploader";

interface Banner { id: string; title: string | null; subtitle: string | null; image_url: string; link_url: string | null; is_active: boolean; sort_order: number; }

const db = supabase as any;

const BannersManager = () => {
  const [banners, setBanners] = useState<Banner[]>([]);
  const load = async () => {
    const { data } = await db.from("store_banners").select("*").order("sort_order");
    setBanners(data || []);
  };
  useEffect(() => { load(); }, []);

  const add = async (urls: string[]) => {
    if (!urls.length) return;
    const { error } = await db.from("store_banners").insert(urls.map((u, i) => ({ image_url: u, sort_order: banners.length + i })));
    if (error) toast.error(error.message); else { toast.success("Banner adicionado"); load(); }
  };
  const update = async (id: string, patch: Partial<Banner>) => {
    setBanners((p) => p.map((b) => (b.id === id ? { ...b, ...patch } : b)));
    await db.from("store_banners").update(patch).eq("id", id);
  };
  const remove = async (id: string) => {
    if (!confirm("Eliminar banner?")) return;
    await db.from("store_banners").delete().eq("id", id);
    load();
  };

  return (
    <div className="space-y-4">
      {banners.map((b) => (
        <div key={b.id} className="flex flex-col sm:flex-row gap-3 p-3 rounded-xl border border-border">
          <img src={b.image_url} alt="" className="w-full sm:w-40 h-24 object-cover rounded-lg" />
          <div className="flex-1 space-y-2">
            <Input placeholder="Título (ex.: -20% em difusores)" defaultValue={b.title || ""} onBlur={(e) => update(b.id, { title: e.target.value })} />
            <Input placeholder="Subtítulo" defaultValue={b.subtitle || ""} onBlur={(e) => update(b.id, { subtitle: e.target.value })} />
            <Input placeholder="Link ao clicar (opcional)" defaultValue={b.link_url || ""} onBlur={(e) => update(b.id, { link_url: e.target.value })} />
          </div>
          <div className="flex sm:flex-col items-center gap-3">
            <Switch checked={b.is_active} onCheckedChange={(v) => update(b.id, { is_active: v })} />
            <Button variant="outline" size="icon" onClick={() => remove(b.id)}><Trash2 size={14} /></Button>
          </div>
        </div>
      ))}
      <MediaUploader kind="image" max={10} value={[]} onChange={add} folder="banners" />
    </div>
  );
};

export default BannersManager;
